import { QueryClient } from '@tanstack/react-query'

import { getAuthFromCache } from 'Common/utils/query/useAuth'

type PrefetchOptions = Parameters<QueryClient['prefetchQuery']>[0]

export function prefetchWhenAuthenticated(queryClient: QueryClient, options: PrefetchOptions) {
    if (!getAuthFromCache()?.data?.token) return undefined

    return queryClient.prefetchQuery(options)
}
